import CashCoin from '../../../shared/assets/categories/CashCoin.png';
import StudentRegular from '../../../shared/assets/categories/StudentRegular.png';
import ServingFood from '../../../shared/assets/categories/ServingFood.png';
import HouseLineRegular from '../../../shared/assets/categories/HouseLineRegular.png';
import SecurityValidation from '../../../shared/assets/categories/SecurityValidation.png';
import EmojiFunnySquare from '../../../shared/assets/categories/EmojiFunnySquare.png';
import Healtcare from '../../../shared/assets/categories/Healtcare.png';
import Shopping from '../../../shared/assets/categories/ShoppingBag.png';
import Taxes from '../../../shared/assets/categories/Taxes.png';
import ConvertRange from '../../../shared/assets/categories/ScisTransparentSupply.png';
import SelfTransfer from '../../../shared/assets/categories/SelfTransfer.png';
import HomeBolt from '../../../shared/assets/categories/HomeBolt.png';
import Healthcare from '../../../shared/assets/categories/Healthcare.png';
import Gift from '../../../shared/assets/categories/Gift.png';
import DatabaseDollar from '../../../shared/assets/categories/DatabaseDollar.png';
import ReportMoney from '../../../shared/assets/categories/ReportMoney.png';
import DeviceDesktopDollar from '../../../shared/assets/categories/DeviceDesktopDollar.png';
import HomeDollar from '../../../shared/assets/categories/HomeDollar.png';
import MoneybagPlus from '../../../shared/assets/categories/MoneybagPlus.png';
import UserDollar from '../../../shared/assets/categories/UserDollar.png';

const CATEGORY_ICONS = {
	shopping: Shopping,
	taxes: Taxes,
	transportation: ConvertRange,
	travel: SelfTransfer,
	utilities: HomeBolt,
	healthcare: Healthcare,
	'gifts & donations': Gift,
	education: StudentRegular,
	'food & dining': ServingFood,
	housing: HouseLineRegular,
	insurance: SecurityValidation,
	'personal care': Healtcare,
	entertainment: EmojiFunnySquare,
	business: DatabaseDollar,
	investment: ReportMoney,
	freelance: DeviceDesktopDollar,
	rental: HomeDollar,
	salary: MoneybagPlus,
	other: UserDollar,
};

export const getCategoryIcon = categoryName =>
	CATEGORY_ICONS[categoryName?.toLowerCase()] ?? CashCoin;
